import { useContext } from 'react';
import { useSelector } from 'react-redux';
import PageContext from './PageContext';
import moneyFormat from '../functions/moneyFormat';
import rateFormat from '../functions/rateFormat';
import PageTooltip from './PageTooltip';
import { TableCell } from '@mui/material';
import displayDateTime from '../functions/displayDateTime';

// pass row object and showOverride flag as props
const RebateAggregateRow = ({ row, count, tableHeader, showOverride,stickyEnabled }) =>{
    // get context variables from parent 
    const {
        editRow, 
        setEditRow, 
        overrideModal, 
        setOverrideModal,
        status,
        rebateInputTypeId
    } = useContext(PageContext);

    // global redux state for company (passed in from other route)
    const companyInfo = useSelector((state) => state.companyInfo);

    // event handler for override click
    const onOverrideClick = () =>{
        // make OverrideModal visible using state from parent 
        setOverrideModal(overrideModal => overrideModal = true);
        // pass correct row to override modal using context variable
        setEditRow(editRow => editRow = row);
    }

    const getRowClassName = (columnOrder) =>{
        // Pass sticky row class if columnOrder is 0 i.e first column and stickyEnabled Prop is true
        return stickyEnabled && columnOrder===0 ? "table-cell-sticky-row": ""
    }

    return (
        <>
            {/* map logic over all columns in row object */}
            {tableHeader.map(el =>
                // logic to apply money format to correct rows
                el['columnname'] == 'blank' ?
                <>
                    {/* Only allow override if user is a Submitter and Company is in the PENDING status */}
                    { ((status == 'Pending' || status == 'Rejected') && showOverride) ?
                    <TableCell className={getRowClassName(el['columnorder'])}>
                        <button class='payout-table-button' onClick={(e)=>onOverrideClick(e)}>Override</button>
                    </TableCell>
                    :<TableCell className={getRowClassName(el['columnorder'])}>
                        <PageTooltip title='disabled'>
                            <button className='payout-table-button-disabled'>Override</button>   
                        </PageTooltip>
                    </TableCell>}    
                </>
                : el['format'] == 'money' ? 
                    <TableCell className={getRowClassName(el['columnorder'])} align='right'>{moneyFormat(row[el['columnname']])}</TableCell>
                : el['format'] == 'rate' ?
                    <TableCell className={getRowClassName(el['columnorder'])} align='right'>{rateFormat(row[el['columnname']], rebateInputTypeId)}</TableCell>
                : el['format'] == 'date' ? 
                    <TableCell className={getRowClassName(el['columnorder'])}>{displayDateTime(row[el['columnname']], true, false)}</TableCell>
                : el['format'] == 'date_ovr_offset' ? 
                    <TableCell className={getRowClassName(el['columnorder'])}>{displayDateTime(row[el['columnname']], true, true)}</TableCell>
                // standard display for other columns 
                : row[el['columnname']] == null ?
                    <TableCell className={getRowClassName(el['columnorder'])}>None</TableCell>
                : <TableCell className={getRowClassName(el['columnorder'])}>{row[el['columnname']]}</TableCell>
            )}
        </>
    );
}

export default RebateAggregateRow;